<template>
    <main class="relative">
        <WYSIWYGEditorToolbar
            v-if="activeComponents.editor.active"
            :key="activeComponents.content.colId"
            :active="activeComponents.editor.active"
            :editor="activeComponents.editor.instance"
            :template-misc-data="{
                templateId: templateVersionModel.templateId,
                name: templateModel.name,
                type: templateModel.type,
            }"
        />

        <div class="h-screen min-h-screen w-full overflow-y-auto py-28 text-center">
            <div class="template-base-wrapper">
                <div
                    :class="[
                        dragging === true ? 'outline-sky-700' : 'focus:outline-hidden',
                        `template-base template-base-inbox relative p-1 ${
                            activeComponents.showBlocks === true ? 'template-show-blocks' : ''
                        }`,
                    ]"
                >
                    <!-- Row wrapper -->
                    <Sortable
                        :list="templateEditModel.template.body"
                        item-key="id"
                        :options="options"
                        @update="(event) => showSortedDocument(event)"
                    >
                        <template #item="{ element }">
                            <div
                                class="list-group-item group/rows relative my-1 py-1 pr-1 pl-1 outline-2 outline-offset-1 outline-solid"
                                :class="
                                    activeComponents.content.rowId === element.id
                                        ? 'outline-amber-400 hover:outline-amber-400'
                                        : 'outline-transparent hover:outline-amber-200'
                                "
                            >
                                <div class="flex">
                                    <!-- Toolbar -->
                                    <div class="h-fit w-8 group-hover/rows:block">
                                        <div class="min-h-screen bg-white">
                                            <!-- Drag handle -->
                                            <div class="handle my-px flex cursor-pointer p-1">
                                                <MdiMouseMoveVertical
                                                    class="h-6 w-6 text-gray-400 hover:text-gray-600"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex-1">
                                        <!-- Col warpper -->
                                        <div
                                            :id="element.id"
                                            :class="element.cssClass"
                                            :style="extractStyles(element.style)"
                                        >
                                            <div
                                                v-for="col in element.cols"
                                                :id="col.id"
                                                :key="col.id"
                                                :class="[
                                                    activeComponents.content.colId === col.id
                                                        ? 'outline-indigo-400'
                                                        : 'outline-transparent hover:outline-indigo-200',
                                                    `${col.cssClass} p-1 outline-2 outline-solid`,
                                                ]"
                                                :style="extractStyles(col.style)"
                                            >
                                                <!-- Col content wrapper -->
                                                <div
                                                    :id="col.content.id"
                                                    :class="[
                                                        activeComponents.showBlocks === true
                                                            ? 'template-show-blocks'
                                                            : '',
                                                        col.content.cssClass,
                                                    ]"
                                                    :style="extractStyles(col.content.style)"
                                                    @mousedown="
                                                        setActiveContent(
                                                            activeComponents,
                                                            col.content,
                                                        )
                                                    "
                                                >
                                                    <WYSIWYGEditorCore
                                                        :model-value="col.content.html"
                                                        @update-content:model-value="
                                                            updateColContent
                                                        "
                                                        @focus-content:model-value="focusColContent"
                                                        @blur-content:model-value="blurColContent"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Sortable>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
    import { ref } from 'vue';
    import { extractStyles, modifyColContent } from '../composables/useTemplateModel';
    import { MdiMouseMoveVertical } from 'materialdesignicons-vue3/icons/';
    import WYSIWYGEditorCore from '../components/WYSIWYGEditorCore.vue';
    import WYSIWYGEditorToolbar from '../components/WYSIWYGEditorToolbar.vue';
    import { Sortable } from 'sortablejs-vue3';

    const props = defineProps({
        templateVersionModel: {
            type: Object,
            required: true,
        },
        templateModel: {
            type: Object,
            required: true,
        },
        templateEditModel: {
            type: Object,
            required: true,
        },
        activeComponents: {
            type: Object,
            required: true,
        },
    });

    const templateVersionModel = props.templateVersionModel;
    const activeComponents = props.activeComponents;
    const templateEditModel = props.templateEditModel;
    const templateModel = props.templateModel;

    const dragging = ref(false);

    const options = {
        handle: '.handle',
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        dragClass: 'dragging',
        animation: '200',
        dataIdAttr: 'id',
        onStart: () => {
            dragging.value = true;
        },
        onEnd: () => {
            dragging.value = false;
        },
    };

    // Update editor content permanently
    const updateColContent = async (editor) => {
        activeComponents.editor.active = true;
        activeComponents.editor.instance = editor;
        modifyColContent(
            templateModel,
            activeComponents.content.rowId,
            activeComponents.content.colId,
            editor.getHTML(),
        );
    };

    // Activate content editor instance
    const focusColContent = async (editor) => {
        activeComponents.editor.active = true;
        activeComponents.editor.instance = editor;
    };

    // Activate content editor instance
    const blurColContent = async (editor) => {
        console.log(
            'TemplatePDF.vue: EVENT BLUR DOM',
            editor.view.dom.parentElement.parentElement.id,
        );
    };

    // Activate row and col content, sidebar context
    const setActiveContent = (content) => {
        if (content.id !== activeComponents.content.id) {
            activeComponents.editor.active = false;
            activeComponents.editor.instance = null;
            activeComponents.content = content;
        }
    };

    const showSortedDocument = (event) => {
        const item = templateEditModel.template.body.splice(event.oldIndex, 1)[0];
        templateEditModel.template.body.splice(event.newIndex, 0, item);
    };
</script>
